export default __webpack_public_path__ + "static/media/SFlogo.b43a6659.png";